import React from 'react'
import { Button, Card, CardContent, CardHeader, DateInput, Input, Label, Select } from '@/shared/ui'

export type RelatorioV2UiFilters = {
  closedFrom: string
  closedTo: string
  maxRows: number
  symbol: string
  targetTimeframe: string
  targetTrend: string
  opportunityType: string
}

export default function RelatorioV2Filters({
  value,
  onChange,
  onSubmit,
  loading,
  matchedHint,
}: {
  value: RelatorioV2UiFilters
  onChange: (next: RelatorioV2UiFilters) => void
  onSubmit: () => void
  loading: boolean
  matchedHint?: string | null
}) {
  return (
    <Card>
      <CardHeader className="text-sm font-medium">Filtros</CardHeader>
      <CardContent className="grid gap-3 md:grid-cols-6">
        <div className="md:col-span-2">
          <Label>Fechadas de</Label>
          <DateInput value={value.closedFrom} onChange={(e) => onChange({ ...value, closedFrom: e.target.value })} className="mt-1 w-full" />
        </div>
        <div className="md:col-span-2">
          <Label>Fechadas até</Label>
          <DateInput value={value.closedTo} onChange={(e) => onChange({ ...value, closedTo: e.target.value })} className="mt-1 w-full" />
        </div>
        <div className="md:col-span-2">
          <Label>Limite de linhas</Label>
          <Input
            type="number"
            min={1}
            max={20000}
            step={100}
            value={value.maxRows}
            onChange={(e) => onChange({ ...value, maxRows: Number(e.target.value) })}
            className="mt-1 w-full"
          />
        </div>

        <div className="md:col-span-2">
          <Label>Símbolo</Label>
          <Input
            value={value.symbol}
            onChange={(e) => onChange({ ...value, symbol: e.target.value })}
            placeholder="Ex.: BTCUSDT (vazio = todos)"
            className="mt-1 w-full"
          />
        </div>

        <div className="md:col-span-2">
          <Label>TF alvo</Label>
          <Select
            value={value.targetTimeframe}
            onChange={(e) => onChange({ ...value, targetTimeframe: (e.target as HTMLSelectElement).value })}
            className="mt-1 w-full"
          >
            <option value="">Todos</option>
            <option value="5">5</option>
            <option value="15">15</option>
            <option value="30">30</option>
            <option value="60">60</option>
            <option value="240">240</option>
            <option value="720">720</option>
            <option value="D">D</option>
            <option value="W">W</option>
            <option value="M">M</option>
          </Select>
        </div>

        <div className="md:col-span-2">
          <Label>Tendência</Label>
          <Select
            value={value.targetTrend}
            onChange={(e) => onChange({ ...value, targetTrend: (e.target as HTMLSelectElement).value })}
            className="mt-1 w-full"
          >
            <option value="">Todas</option>
            <option value="bullish">Bullish</option>
            <option value="bearish">Bearish</option>
          </Select>
        </div>

        <div className="md:col-span-3">
          <Label>Tipo de oportunidade</Label>
          <Input
            value={value.opportunityType}
            onChange={(e) => onChange({ ...value, opportunityType: e.target.value })}
            placeholder="Ex.: breakout (vazio = todos)"
            className="mt-1 w-full"
          />
        </div>

        <div className="md:col-span-3 flex items-end justify-between gap-2">
          <div className="text-xs text-foreground/70">{matchedHint || ''}</div>
          <Button onClick={onSubmit} disabled={loading}>
            {loading ? 'Carregando…' : 'Aplicar'}
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
